<template>
  <div class="ui card"
    :class="{
      hasalert: (wdSorted['red'].length > 0 || wdSorted['mute'].length > 0),
      stts21kdfslds: (wd.status == 21)
    }"
    :data-wdtype="wdtype"
    @mouseover="hoverState(true)"
    @mouseleave="handleMouseLeave"
    @mouseenter="handleMouseEnter"
    @mousemove="handleMouseMove"
  >
    <!-- Tooltip that follows the cursor -->
    <div v-if="showSuppressedMsg && isSuppressed"
         class="suppressed-tooltip"
         :style="{ top: tooltipY + 'px', left: tooltipX + 'px' }">
         Upgrade your plan to unlock this alert and access all 25+ critical notifications
    </div>



    <div class="content"
      :class="{'greyed-out-card': isSuppressed}"
    >

      <div class="header" style="text-shadow: 1px 1px 2px #DDD; font-size:24px;">
        <span v-show="newAlertCount>0" class="ui red horizontal label" style="text-shadow:none; padding: 5px 6px 4px; margin: -21px; position: absolute;">{{newAlertCount}} new</span>
        <i :class="(wd.status===0 ? 'green' : 'orange') + ' power icon'"></i>

        {{ wdInfo[wdtype].name }}
        <span v-if="wd.status===20">[preview]</span>

        &nbsp;<a v-if="isConfigurable"
            style="color:steelblue; font-size:small; font-weight:normal; text-shadow: none;"
            @click="showConfiguration=!showConfiguration">
          <i class="cogs icon"></i>Configure
        </a>
      </div>



      <small class="cchfreq"> current check frequency: {{wdInfo[wdtype].ccf}} </small>
      <form autocomplete="off" onsubmit="return false;">
        <div class="ui mini right icon input"
              style="position:absolute;top:38px;right:15px;"
              v-if="!accountLevelWd">
          <div :style="currentTab!==1 ? 'display : none' : null" class="ui mini floating dropdown labeled icon button">
            <i class="filter icon"></i>
            <span class="text">Filter</span>
            <div class="menu">
              <div class="header">
                Filter by issue status
              </div>
              <div class="item" data-value="1">
                <i class="unhide icon"></i>
                Seen
              </div>
              <div class="item" data-value="2">
                <i class="time icon"></i>
                In progress
              </div>
              <div class="divider"></div>
              <div class="header">
                Filter by alert type
              </div>
              <div class="item" data-value="3">
                <i class="orange circle icon"></i>
                Warning
              </div>
              <div class="item" data-value="4">
                <i class="red circle icon"></i>
                Alert
              </div>
            </div>
          </div>
          <input v-model="filterString" type="search"
                v-if="!accountLevelWd"
                v-prevent-autofill="filterString"
                :style="filterString?'background-color:lightsalmon;border:1px solid orange;':''"
                placeholder="Search" style="padding:4px">
          <i class="search icon"></i>
        </div>
      </form>

      <div :class="{'muteRingAni' : muteRingAni}"></div>


      <!-- Tab control buttons -->
      <div class="wdTabControls">
        <a v-for="x, i in tabsToDisplay"
          :class="'ui small label ' + (currentTab==i ? wdl[x].color+' actvtb' : '') + (wdSorted[x].length>0 ? '':' disabled')"
          v-on:click="setCurrentTab(i)"
          :data-html="wdl[x].blurb"
          data-variation="inverted mini"
          :data-position="wdl[x].bpos">
            <i :class="wdl[x].icon + ' icon ' + (currentTab!=i ? wdl[x].color:'') + (wdSorted[x].length==0&&(x=='red'||x=='amber') ? ' outline':'')"></i>
           {{ wdSorted[x].length }}
        </a>
        <a v-on:click="setCurrentTab(99)" :class="'ui small label ' + (currentTab==99?'grey actvtb':'')">info 1</a>
        <div v-if="$parent.$parent.onboarding.wdtabs" class="onboarding ui left pointing large yellow label" style="position:absolute; padding-bottom:9px; margin-top:4px; z-index:11;" data-onboarding="wdtabs">
          These are Tabs! - <small >Click any of them to dismiss this note</small>
        </div>
        <transition name="fadeLeft">
        <small v-show="newAlertCount>0&&currentTab==1" @click="markAllSeen(wdtype)" class="markAllSeen">
          <i v-if="markAllSeenInProgress" class="black tight notched circle loading icon"></i>
          [mark all new as seen]
        </small>
        </transition>
      </div>


      <!-- Tabs -->
      <div class="wdTabCwrap">
      <div :class="{active:topShader}" class="shadow-top"></div>
      <div :class="'wdTabC ui ' + (currentTab==99 ? 'grey' : wdl[tabsToDisplay[currentTab]].color) + ' basic segment'"
          v-on:mousewheel="fixScrolling"
          v-on:scroll="setInnerShaders"
          :style="setWDCHeight()">
      <transition name="fadeLeft" mode="out-in">

        <AmazonChoiceBadgeConfig v-if="showConfiguration && wdtype == 'amazonChoiceBadge'"/>
        <StarRatingRecentChangeConfig v-if="showConfiguration && wdtype == 'starRatingRecentChange'"/>
        <CategoryChangeConfig v-if="showConfiguration && wdtype == 'productCategoryRecentChange'"/>
        <BestSellerBadgeConfig v-if="showConfiguration && wdtype == 'bestSellerBadge'"/>
        <ListingSuspendedConfig v-if="showConfiguration && wdtype == 'listingSuspended'"/>
        <SubscribeAndSaveConfig v-if="showConfiguration && wdtype == 'subscribeAndSave'"/>
        <ParentProductChangeConfig v-if="showConfiguration && wdtype == 'parentProductChange'"/>
        <SpreadsheetConfig v-if="showConfiguration && wdtype == 'inventory'" v-bind:watch-dog-name="'FBA Stock'" v-bind:api-prefix="'inventory'"/>
        <SpreadsheetConfig v-if="showConfiguration && wdtype == 'fbmInventory'" v-bind:watch-dog-name="'FBM Stock'" v-bind:api-prefix="'fbm_inventory'"/>
        <SpreadsheetConfig v-if="showConfiguration && wdtype == 'salesDrop'" v-bind:watch-dog-name="'Sales Volume'" v-bind:api-prefix="'salesdrop'"/>
        <ProductDetailsRecentChangeConfig v-if="showConfiguration && wdtype == 'productDetailsRecentChange'"/>
        <FBAFeeChangeConfig v-if="showConfiguration && wdtype == 'fbaFeeChange'"/>
        <StoreFrontWhiteListConfig v-if="showConfiguration && (wdtype == 'numberOfSellers' || wdtype == 'lostBuybox')" :watchDogType="wdtype"/>
        <div v-else-if="currentTab==99" key="99" class="ui grid">

          <div class="six wide column">
            <div class="ui center aligned basic segment badges" style="margin-top:40px; ">

              <a class="ui green tiny statistic" @click="currentTab=0">
                <div class="value">{{ wdSorted.ok.length }}</div><div class="label"><i class="green check icon"></i>OK</div>
              </a>
              <a class="ui red tiny statistic" @click="currentTab=1">
                <div class="value"><i class="exclamation icon"></i> {{ wdSorted.red.length }} </div><div class="label">Issues</div>
              </a>
              <a class="ui blue tiny statistic" @click="currentTab=2" v-show="wdSorted.mute.length>0">
                <div class="value">{{ wdSorted.mute.length }}</div><div class="label"><i class="mute alarm outline icon"></i></div>
              </a>
            </div>
          </div>

          <div class="nine wide column" >
            <div class="ui center aligned basic very padded segment" style="margin-top:30px; min-height:150px; border:1px solid #eee; border-radius:6px;">
              <span class="ui left corner label"><i class="info circle icon"></i></span>
               {{ wdInfo[wdtype].desc }}
            </div>
          </div>

        </div>
        <div class="ui list" v-else-if="currentTab!==99" :key="currentTab">
          <div v-if="wdSorted[tabsToDisplay[currentTab]].length==0">
            &nbsp; &nbsp; &nbsp; &nbsp;
            <span v-if="tabsToDisplay[currentTab]=='ok'">No items to show</span>
            <span v-if="tabsToDisplay[currentTab]=='red' && wdSorted.red.length == 0">No current Alerts</span>
            <span v-if="tabsToDisplay[currentTab]=='mute'">No Muted alerts or Alerts marked as Done</span>
          </div>
          <div v-if="filterString!=='' || filterCategory !== ''">
            <span v-if="filteredResults(wdSorted[tabsToDisplay[currentTab]]).length==0">No items match your filter, try a different one.</span>
          </div>

          <WatchdogItem
            v-for="item in paginatedItems"
            :item="item"
            :itemtype="tabsToDisplay[currentTab]"
            :itemprops="wdl[tabsToDisplay[currentTab]]"
            :wdtype="wdtype"
            :groupByParent="groupByParent"
            :detSel="detSel"
            @muteRingAni="doMuteRingAni"
            :key="item.watchDogItemId"/>

          <!-- Pagination Controls -->
          <div v-if="totalPages > 1" class="ui center aligned segment" style="margin: 10px 0; padding: 10px;">
            <div class="ui mini pagination menu">
              <a class="item" :class="{ disabled: currentPage === 0 }" @click="prevPage">
                <i class="left chevron icon"></i>
              </a>

              <!-- Page numbers -->
              <a v-for="page in Math.min(5, totalPages)" :key="page"
                 class="item"
                 :class="{ active: currentPage === getPageNumber(page) }"
                 @click="goToPage(getPageNumber(page))">
                {{ getPageNumber(page) + 1 }}
              </a>

              <a class="item" :class="{ disabled: currentPage >= totalPages - 1 }" @click="nextPage">
                <i class="right chevron icon"></i>
              </a>
            </div>

            <div class="ui mini message" style="margin-top: 5px;">
              Showing page {{ currentPage + 1 }} of {{ totalPages }}
              ({{ totalItems }} total items)
            </div>
          </div>

          <a v-if="tabsToDisplay[currentTab]=='red' && wdSorted.mute.length>0" class="item" @click="currentTab=2" key="rndmkey349857">
            <i class="right blue warning icon"></i>
            <div class="content">
              <div class="description">
                <span v-if="(wdSorted.mute.length-muteCount)>0">
                  You {{wdSorted.red.length>0 ? 'also':''}} have <strong>{{wdSorted.mute.length - muteCount}}</strong> issue{{wdSorted.mute.length>1 ? 's':''}} marked as Done.
                </span>
                <span v-if="muteCount>0">
                  &nbsp; <strong>{{muteCount}}</strong> product{{muteCount>1?'s':''}} on Mute.
                </span>
              </div>
            </div>
          </a>

  <!--        <PartnerBanner v-if="showPartnerCards && tabsToDisplay[currentTab]==='red' && wdtype.toLowerCase().includes('inventory')" v-on:dismiss="showPartnerCards = false" />-->

        </div>
      </transition>
      </div>
      </div>
    <div :class="{active:bottomShader}" class="shadow-bottom"></div>
    </div><!-- /content -->

    <div v-if="false&&!accountLevelWd" class="extra content">
      <div v-if="isConfigurable" style="width:160px;float:left"><a v-on:click="showConfiguration=!showConfiguration"><i class="cogs icon"></i>Configure</a></div>
      <div class="ui mini left icon input" style="margin:-5px 0px -5px 5px; float:right">
        <input v-model="filterString" v-prevent-autofill="filterString" type="search" placeholder="Filter results...">
        <i class="filter icon"></i>
      </div>
      <b v-show="filterString" style="color:orange;float:right;">Current filter:</b>
    </div>

  </div>
  </template>

  <script>
  import $ from 'jquery'
  import WatchdogItem from './WatchdogItem'
  import AmazonChoiceBadgeConfig from './settings/AmazonChoiceBadgeConfig'
  import StarRatingRecentChangeConfig from './settings/StarRatingRecentChangeConfig'
  import CategoryChangeConfig from './settings/CategoryChangeConfig'
  import BestSellerBadgeConfig from './settings/BestSellerBadgeConfig'
  import ListingSuspendedConfig from './settings/ListingSuspendedConfig'
  import SpreadsheetConfig from './settings/SpreadsheetConfig'
  import ProductDetailsRecentChangeConfig from './settings/ProductDetailsRecentChangeConfig'
  import FBAFeeChangeConfig from './settings/FBAFeeChangeConfig'
  import StoreFrontWhiteListConfig from './settings/StoreFrontWhiteListConfig'
  import SubscribeAndSaveConfig from './settings/SubscribeAndSaveConfig'
  import ParentProductChangeConfig from './settings/ParentProductChangeConfig'
  import PartnerBanner from './PartnerBanner'
  export default {
    components: {
      WatchdogItem, AmazonChoiceBadgeConfig, StarRatingRecentChangeConfig, CategoryChangeConfig, BestSellerBadgeConfig, ListingSuspendedConfig, SpreadsheetConfig, ProductDetailsRecentChangeConfig, FBAFeeChangeConfig, StoreFrontWhiteListConfig, SubscribeAndSaveConfig, ParentProductChangeConfig, PartnerBanner
    },
    data () {
      return {
        wdInfo: {
          'badSellerFeedback': {'name': 'Bad Seller Feedback', 'desc': 'Alert if there is new recent bad seller feedback.', 'ccf': '2 hours'},
          'listingSuspended': {'name': 'Suspended Listings', 'desc': 'Check if Amazon indicates a problem with a listing.', 'ccf': '10 minutes'},
          'lostBuybox': {'name': 'Buy-box', 'desc': 'Alert if the buybox is lost to another seller.', 'ccf': '30 minutes'},
          'salesDrop': {'name': 'Sales Volume', 'desc': 'Alert if there is a sharp drop in the sales volume. Warn if sales are slowly decreasing over a few days.', 'ccf': '30 minutes'},
          'imageMissing': {'name': 'Main Image', 'desc': 'Alert if main image of the product had been taken down.', 'ccf': '30 minutes'},
          'starRatingRecentChange': {'name': 'Star Rating Change', 'desc': 'Alert if rating changes by half a star. Optional: warn on every 0.1 change too.', 'ccf': '2.5 hours'},
          'badReview': {'name': 'Latest Reviews 1', 'desc': 'Alert when there is bad review in the Latest Reviews section at #1-#3. Warn when there is bad review at #4-#10.', 'ccf': '2 hours'},
          'topReview': {'name': 'Top Rated Reviews', 'desc': 'Alert when there is bad review in the Top Rated Reviews section at #1-#3. Warn when there is bad review at #4-#10.', 'ccf': '4 hours'},
          'noAddToCart': {'name': 'Add-to-Cart Button', 'desc': 'Alert if there is no add to cart button on the listing.', 'ccf': '30 minutes'},
          'keyword': {'name': 'Search Rank', 'desc': 'Alert if the Search Rank for a given Keyword falls below a treshold', 'ccf': '6 hours'},
          'productDetailsRecentChange': {'name': 'Product Details Change', 'desc': 'Track the Title, Image, Bulletpoints, Description, Dimension and Weight changes of a product.', 'ccf': '30 minutes'},
          'numberOfSellers': {'name': 'Hijacker Alert', 'desc': 'Monitor the number of active sellers on a listing.', 'ccf': '15 minutes'},
          'bestSellerBadge': {'name': 'Best Seller Badge', 'desc': 'Monitor whether the product has the Best Seller Badge in one of its categories.', 'ccf': '30 minutes'},
          'productCategoryRecentChange': {'name': 'Main/Sub-Cat Change', 'desc': 'Alert when the sub-category or the main category of a product has changed', 'ccf': '1.5 hours'},
          'price': {'name': 'Price Change', 'desc': 'Alert when another seller has a lower price than you.', 'ccf': '15 minutes'},
          'searchBan': {'name': 'Search Result Suppression', 'desc': 'Alert when the product does not appear in the search results.', 'ccf': '3 hours'},
          'inventory': {'name': 'FBA Stock', 'desc': 'Alert when the product goes low on stock.', 'ccf': '90 minutes'},
          'fbmInventory': {'name': 'FBM Stock', 'desc': 'Alert when the product goes low on stock.', 'ccf': '90 minutes'},
          'fbaFeeChange': {'name': 'FBA Fee Change', 'desc': 'Alert when the latest orders\' FBA Fee changed', 'ccf': '1 day'},
          'prime': {'name': 'Prime badge', 'desc': 'Monitor whether the product has a Prime Badge', 'ccf': '30 minutes'},
          'amazonChoiceBadge': {'name': 'Amazon\'s choice badge', 'desc': 'Monitor whether the product has an Amazon\'s choice badge', 'ccf': '30 minutes'},
          'subscribeAndSave': {'name': 'Subscribe and Save', 'desc': 'Monitor whether the product has a Subscribe and Save option', 'ccf': '30 minutes'},
          'parentProductChange': {'name': 'Parent Product Change', 'desc': 'Alert when the parent product has changed', 'ccf': '31 minutes'},
          'adultClassification': {'name': 'Adult Classification', 'desc': 'Alert when Amazon classifies the listing as adult, or removes that classification', 'ccf': '30 minutes'},
          'reviewHealth': {'name': 'Review Health', 'desc': 'Alert when the star rating or rating count drops, or new critical reviews come in. Checked once a day from Amazon\'s review data, which runs 1–2 days behind.', 'ccf': '1 day'}
        },
        groupByParent: (this.wdtype === 'badReview' || this.wdtype === 'topReview' || this.wdtype === 'keyword' || this.wdtype === 'starRatingRecentChange' || this.wdtype === 'inventory' || this.wdtype === 'fbmInventory'),
        accountLevelWd: (this.wdtype === 'listingSuspended' || this.wdtype === 'badSellerFeedback'),
        ishovered: false,
        currentTab: 99,
        muteRingAni: false,
        tabsToDisplay: ['ok', 'red', 'mute'],
        wdl: {
          ok: { color: 'green', listcolor: { 0: 'green', 99: 'grey' }, listicon: 'check', icon: 'checkmark', bpos: 'bottom left', sortfn: (i) => (i.status === 99 || i.status === 0) && !i.muted, blurb: 'Products without issues' },
          red: { color: 'red', listcolor: { 1: 'orange', 2: 'red' }, listicon: 'warning circle', icon: 'alarm', bpos: 'bottom center', sortfn: (i) => (i.status === 1 || i.status === 2) && !i.muted && i.issueStatus < 3, blurb: 'Issues needing attention' },
          amber: { color: 'orange', listcolor: { 1: 'orange' }, listicon: 'warning circle', icon: 'alarm', bpos: 'bottom center', sortfn: (i) => i.status === 1 && !i.muted && i.issueStatus < 3, blurb: 'Issues needing attention' },
          mute: { color: 'blue', listcolor: { 1: 'blue', 2: 'blue' }, listicon: 'triangle', icon: 'mute alarm outline', bpos: 'bottom right', sortfn: (i) => (i.issueStatus === 3 && (i.status === 1 || i.status === 2)) || i.muted, blurb: '- Issues marked as Done<br>&nbsp;&nbsp;<small>and</small><br>- Muted Products' },
        },
        emailAlertIndicator: this.wd.alertsEnabled,
        filterString: '',
        filterCategory: '',
        dimTimeOutObj: null,
        topShader: false,
        bottomShader: false,
        markAllSeenInProgress: false,
        showConfiguration: false,
        isConfigurable: ['starRatingRecentChange', 'productCategoryRecentChange', 'bestSellerBadge', 'listingSuspended', 'inventory', 'fbmInventory', 'productDetailsRecentChange', 'salesDrop', 'fbaFeeChange', 'numberOfSellers', 'lostBuybox', 'amazonChoiceBadge', 'subscribeAndSave', 'parentProductChange'].indexOf(this.wdtype) >= 0,
        hoveredForSomeTime: false,
        hoveredForALittle: false,
        showSuppressedMsg: false,
        tooltipX: 0,
        tooltipY: 0,
        // Pagination
        currentPage: 0,
        itemsPerPage: 10

      }
    },
    props: ['wdtype', 'wd', 'detSel', 'nth', 'scrollIntoView', 'suppressedWatchdogs'],
    computed: {
      isSuppressed () {
        const backendType = this.toBackendEnumFormat(this.wdtype)
        const result = Array.isArray(this.suppressedWatchdogs) && this.suppressedWatchdogs.includes(backendType)
        console.log('[Watchdog] wdtype:', this.wdtype, 'as backendType:', backendType, 'suppressedWatchdogs:', this.suppressedWatchdogs, 'isSuppressed:', result)
        return result
      },
      wdSorted: function () {
        const wdArr = Object.values(this.wd.items) // obj -> arr so we can use filter
        let wds = { }

        for (let i in this.tabsToDisplay) {
          // filter to tabs (groupify first if needed)
          if (this.groupByParent) {
            wds[ this.tabsToDisplay[i] ] = this.groupify(wdArr).filter(this.wdl[ this.tabsToDisplay[i] ].sortfn)
          } else {
            wds[ this.tabsToDisplay[i] ] = wdArr.filter(this.wdl[ this.tabsToDisplay[i] ].sortfn)
          }

          // Filter by seller accounts  (if filter is on)
          if (this.$parent.filterBySellAcc.length > 0) wds[this.tabsToDisplay[i]] = wds[this.tabsToDisplay[i]].filter((i) => this.$parent.filterBySellAcc.indexOf(i.sellerId) >= 0)
          // Filter by countries selection (if filter is on)
          if (this.$parent.filterByMarket.length > 0) wds[this.tabsToDisplay[i]] = wds[this.tabsToDisplay[i]].filter((i) => this.$parent.filterByMarket.indexOf(i.marketplace) >= 0)

          // sort products by name (for now)
          if (!this.accountLevelWd) {
            var products = this.$parent.$parent.worldStore.products
            wds[this.tabsToDisplay[i]].sort(function (a, b) {
              var prodA = a.productId && products[a.productId] ? products[a.productId] : null
              var prodB = b.productId && products[b.productId] ? products[b.productId] : null
              var titleA = prodA && prodA.productTitle ? prodA.productTitle : ''
              var titleB = prodB && prodB.productTitle ? prodB.productTitle : ''
              return titleA < titleB ? -1 : (titleA > titleB ? 1 : 0)
            })
            // if it is the "red" alerts tab, need to sort the warnings and alerts too
            if (this.tabsToDisplay[i] === 'red') wds[this.tabsToDisplay[i]].sort((a, b) => b.status - a.status)
          }
        }
        return wds
      },
      newAlertCount: function () {
        return this.wdSorted['red'].reduce((prevVal, item) => prevVal + ((item.issueStatus === 0 && !item.muted) ? 1 : 0), 0)
      },
      muteCount: function () {
        return this.wdSorted['mute'].reduce((prevVal, item) => prevVal + (item.muted ? 1 : 0), 0)
      },
      showPartnerCards: {
        get: function () {
          return this.$parent.showPartnerCards
        },
        set: function () {
          this.$parent.showPartnerCards = false
        }
      },
      // Pagination computed properties
      totalItems: function () {
        return this.filteredResults(this.wdSorted[this.tabsToDisplay[this.currentTab]]).length
      },
      totalPages: function () {
        return Math.ceil(this.totalItems / this.itemsPerPage)
      },
      paginatedItems: function () {
        const filteredItems = this.filteredResults(this.wdSorted[this.tabsToDisplay[this.currentTab]])
        const start = this.currentPage * this.itemsPerPage
        const end = start + this.itemsPerPage
        return filteredItems.slice(start, end)
      },
    },
    created: function () {
      if (this.wdSorted['red'].length > 0 || (this.wdSorted['mute'].length - this.muteCount) > 0) this.currentTab = 1
      this.$parent.wdNewErrorCounts[this.wdtype] = this.newAlertCount
      this.$parent.wdMenuUpdateTrigger = this.wdtype + this.newAlertCount
    },
    mounted: function () {
      $(this.$el).find('a[data-html]').popup({ delay: { show: 500, hide: 0 }, transition: 'fade' })
      $(this.$el).find('.ui.dropdown').dropdown({
        onChange: (value) => { this.filterCategory = value }
      })
      console.log('[DEPLOY TEST] Watchdog.vue loaded at', new Date())
      console.log('[Watchdog] prop suppressedWatchdogs from parent:', this.suppressedWatchdogs)
    },
    watch: {

      suppressedWatchdogs (val) {
        console.log('[Watchdog] suppressedWatchdogs changed:', val)
      },
      detSel: function (val) {
        // we set the new height with jQuery; v-bind wont always refresh it
        //  as it does no know if the user manually resized the box or not
        $(this.$el).find('.wdTabC').attr('style', this.setWDCHeight())
        // old: :style="'height:' + (wd.items.length * 40) + 'px;'"
      },
      wd: function () {
        if (!this.ishovered && (this.wdSorted['red'].length > 0 || (this.wdSorted['mute'].length - this.muteCount) > 0)) this.currentTab = 1
        this.emailAlertIndicator = this.wd.alertsEnabled
      },
      // Only keep this watcher for currentTab
      currentTab () {
        // REMOVE: itemsPerPage
      },
      filterString () {
        // REMOVE: itemsPerPage
      },
      filterCategory () {
        // REMOVE: itemsPerPage
      },
      newAlertCount: function () {
        this.$parent.wdNewErrorCounts[this.wdtype] = this.newAlertCount
        this.$parent.wdMenuUpdateTrigger = this.wdtype + this.newAlertCount
      },
    },
    methods: {
      handleMouseEnter () {
        if (this.isSuppressed) {
          this.showSuppressedMsg = true
        }
      },
      handleMouseMove (event) {
        if (this.isSuppressed) {
          this.tooltipX = event.clientX + 15 // position near cursor
          this.tooltipY = event.clientY + 15
        }
      },
      handleMouseLeave () {
        this.showSuppressedMsg = false
        this.hoverState(false)// 🔁 Triggers global dimming reset
      },
      toBackendEnumFormat (str) {
        return str.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase()
      },
      markAllSeen: function (wdtype) {
        const watchDogIds = new Set(Object.values(this.wd.items).filter(i => (i.status === 1 || i.status === 2) && !i.muted && i.issueStatus === 0).map(i => i.watchDogId))
        if (watchDogIds.size > 0) {
          const timestamp = Date.now()
          this.$parent.$parent.stateChangeRequestInFlight.add(timestamp)
          this.markAllSeenInProgress = true
          this.$http.put('/api/sentinel/watchdog/bulk-set-issue-status', {issueStatus: 1, watchDogIds: watchDogIds})
            .then((response) => {
              // success
              const items = Object.values(this.wd.items)
              for (let i = 0; i < items.length; ++i) {
                const item = items[i]
                if (watchDogIds.has(item.watchDogId)) item.issueStatus = 1
              }
              this.markAllSeenInProgress = false
              this.$parent.$parent.stateChangeRequestInFlight.delete(timestamp)
            }, (response) => {
              this.markAllSeenInProgress = false
              this.$parent.$parent.stateChangeRequestInFlight.delete(timestamp)
            })
        }
      },
      setCurrentTab: function (i) { this.currentTab = i; this.$parent.$parent.onboarder('wdtabs') },
      // @TODO: rewrite text-search filter as 'watch', not a func + optimise wdSorted calculation (redundant at the mo)
      filteredResults: function (arr) {
        if ((this.filterString === '' && this.filterCategory === '') || this.accountLevelWd || this.wdtype === 'keywords') return arr
        else {
          let cat = Number(this.filterCategory)
          return arr.filter((item) => {
            if (cat > 0 && this.currentTab === 1) {
              if (cat < 3 && item.issueStatus !== cat) return false
              if (cat >= 3 && (item.status !== cat - 2)) return false
            }
            return this.$parent.$parent.worldStore.products[item.productId].productTitle.toLowerCase().indexOf(this.filterString.toLowerCase()) >= 0 || this.$parent.$parent.worldStore.products[item.productId].productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, '$1').toLowerCase().indexOf(this.filterString.toLowerCase()) >= 0
          })
        }
      },
      fixScrolling: function (e) {
        if (!this.hoveredForSomeTime) return // fixate the scroll only if user has been on this box for some time
        let t = $(this.$el).find('.wdTabC')
        if (t.innerHeight() === t.get(0).scrollHeight) return
        if (e.wheelDelta > 0 && t.scrollTop() === 0) {
          e.preventDefault()
        } else {
          if (e.wheelDelta < 0 && (t.scrollTop() === t.get(0).scrollHeight - t.innerHeight())) {
            e.preventDefault()
          }
        }
      },
      setInnerShaders: function (e) {
        let t = $(this.$el).find('.wdTabC')
        this.topShader = (t.scrollTop() > 3)
        this.bottomShader = (t.get(0).scrollHeight - t.innerHeight() - 5 >= t.scrollTop())
      },
      setWDCHeight: function () {
        if (this.detSel === 'wc') return 'height:240px;' // 110 + 14 + 7    + 10
        if (this.currentTab === 99) return ''
        let n = this.wdSorted[this.tabsToDisplay[this.currentTab]].length
        return 'height:' + (n > 4 ? '525' : n * 130 + 20) + 'px;'
      },
      groupify: function (a) {
        let seen = new Set()
        return a.filter(item => {
          return (!item.productGroupId && !item.productCollectionId) ||
            (!item.productGroupId || seen.has(item.productGroupId) ? false : seen.add(item.productGroupId)) ||
            (!item.productCollectionId || seen.has(item.productCollectionId) ? false : seen.add(item.productCollectionId))
        })
      },
      hoverState: function (state) {
        if (this.ishovered === state) return // prev retrigger
        if (this.$parent.dashboardIsAnimating === true) return // do nothing if dashboard is animating
        this.ishovered = state

        // qweqwe
        // if (this.ishovered) setTimeout(() => { if (this.ishovered) this.hoveredForALittle = true }, 500)
        // else this.hoveredForALittle = false

        // only enable scrollable content after 800ms -> Browser & OS don't get distracted while scrolling the page
        if (this.ishovered) setTimeout(() => { if (this.ishovered) $(this.$el).find('.wdTabC').css('overflow-y', 'auto') }, 800)
        else $(this.$el).find('.wdTabC').css('overflow-y', 'hidden')

        // set bool if user has been on hover for some time (used for box scroll capture)
        if (this.ishovered) setTimeout(() => { if (this.ishovered) this.hoveredForSomeTime = true }, 2000)
        else this.hoveredForSomeTime = false

        // if scrollIntoView setting is ON autocenter the box
        if (this.scrollIntoView) setTimeout(() => { if (this.ishovered) this.scrollIntoViewIfOutOfView(this.$el) }, 500)

        // dim background, if hovered for a while
        // $('#wdCont .card').not(this.$el).css('z-index', 0) // leave this - might need it later
        $(this.$el).css('z-index', 99) // add: set the others to 0
        if (state) setTimeout(() => { if (this.ishovered) $('#darkbackgr').stop().fadeIn(1200) }, 2000) // hover on: wait then dim
        else $('#darkbackgr').stop().fadeOut(500) // hover off: start to immediatelly

        // once left, set the z-index to 0, not straight away so it doesnt flicker
        clearTimeout(this.dimTimeOutObj)
        if (!state) this.dimTimeOutObj = setTimeout(() => $(this.$el).css('z-index', 0), 500)
      },
      scrollIntoViewIfOutOfView: function (el) {
        const topOfPage = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        const heightOfPage = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        const elH = el.offsetHeight
        if (elH > heightOfPage) return null // box is taller than the screen, let the user position it
        let elY = 0
        for (let p = el; p && p.tagName !== 'BODY'; p = p.offsetParent) { elY += p.offsetTop }
        // console.log(topOfPage, heightOfPage, elH, elY) // oldalscroll, screenheight, elHeight, elScroll
        if ((topOfPage + heightOfPage) < (elY + elH) && this.nth !== 0) {
          this.stopScrollAniOnUserEvent()
          $('body,html').stop().animate({scrollTop: elY - heightOfPage + elH + 30}, 700, this.releaseUserEventListener)
        } else if (elY < topOfPage) {
          this.stopScrollAniOnUserEvent()
          $('body,html').stop().animate({scrollTop: elY - 30}, 700, this.releaseUserEventListener)
        } else $('body,html').stop()
      },
      stopScrollAniOnUserEvent: function () {
        // stop the animation immediatelly
        $('body,html').on('scroll wheel DOMMouseScroll mousewheel touchmove', function () {
          $('body,html').stop()
          // workin in progress: @TODO continue autoscroll if user interrupted it but stayed in hover
          // console.log('autoscroll stopped')
          // since the autoscroll was interupted, wait a bit and run again IF still in hover
          // setTimeout(() => { if (this.ishovered) this.scrollIntoViewIfOutOfView(this.$el) }, 400)
        })
      },
      releaseUserEventListener: function () {
        $('body,html').off('scroll wheel DOMMouseScroll mousewheel touchmove')
      },
      doMuteRingAni: function () {
        this.muteRingAni = true
        setTimeout(() => { this.muteRingAni = false }, 1100)
      },
      isWatchdogTypeSuppressed (wdt) {
        const backendType = this.toBackendEnumFormat(wdt)
        const result = Array.isArray(this.suppressedWatchdogs) && this.suppressedWatchdogs.includes(backendType)
        return result
      },
      // Pagination methods
      prevPage: function () {
        if (this.currentPage > 0) {
          this.currentPage--
        }
      },
      nextPage: function () {
        if (this.currentPage < this.totalPages - 1) {
          this.currentPage++
        }
      },
      goToPage: function (page) {
        if (page >= 0 && page < this.totalPages) {
          this.currentPage = page
        }
      },
      getPageNumber: function (index) {
        if (this.totalPages <= 5) {
          return index - 1
        }

        let startPage = Math.max(0, this.currentPage - 2)
        let endPage = Math.min(this.totalPages - 1, startPage + 4)

        if (endPage - startPage < 4) {
          startPage = Math.max(0, endPage - 4)
        }

        return startPage + index - 1
      },
    },
  }
  </script>

  <style>
  .fade-enter-active, .fade-leave-active {transition: opacity 1s;}
  .fade-enter, .fade-leave-to {opacity: 0;}
  .fade-leave, .fade-enter-to {opacity: 1;}

  #wdCont .wdTabC {padding: 5px 0px 0px 0px; position:relative; min-height:140px; max-height:360px; overflow-y:hidden; margin-top:3px; transition: all 0.5s; overflow-x:hidden;}
  #wdCont .wdTabC::-webkit-scrollbar {-webkit-appearance: none; width: 7px;}
  #wdCont .wdTabC::-webkit-scrollbar-thumb {border-radius: 4px; background-color: rgba(0,0,0,.3);}
  #wdCont .wdTabC::-webkit-scrollbar:horizontal {height: 0px;}

  #wdCont .wdTabC .wdesc {position: relative; top:40px; margin:auto; width:320px; color:#555; transition: all 0.5s;}
  #wdCont.wide .wdTabC .wdesc {top:70px; }

  #wdCont.wide .wdTabC  {min-height:220px; max-height:700px; resize:vertical;}

  #wdCont .card  { box-shadow: 1px 2px 6px #aaa; width: 46%; transition: width 0.5s; transition-delay: 0.5s;}
  #wdCont.wide .card  {width: 100%; }

  #wdCont .card:hover  {z-index:99; box-shadow:none;}

  #wdCont .card.hasalert {border-left: solid 1px #d22;}

  #wdCont .wdTabControls {margin: 5px 0 -4px 0;}
  #wdCont .wdTabControls a {border-radius: 5px 5px 0px 0px; padding-bottom: 7px; transition:all .3s; background-color: #fff; border: 1px solid #ddd; border-bottom: 0;}
  #wdCont .wdTabControls .actvtb {opacity:1;}

  #wdCont.wide .wdTabCwrap::after {cursor: se-resize; pointer-events:none; content: "\21F2"; font-size: 17px; position: absolute; height: 11px; width: 9px; text-align: center; bottom:13px; right:14px; color:#777; background-color: #fff; line-height: 7px;}

  #wdCont .badges {padding-top:20px;}
  #wdCont .badges a {padding:10px; margin:0 30px 0 0; border-radius:6px; text-shadow: 1px 1px 2px #ccc}
  #wdCont .badges a:hover {background-color: #f6f6f6;}
  body{ scroll-behavior: smooth; }

  #wdCont .cchfreq {color:#999; position:absolute; top:8px; right:15px; font-weight:normal;}
  #wdCont .card .markAllSeen {color:#777; margin-left:30px;}
  #wdCont .card:hover .markAllSeen {text-decoration: underline; cursor: pointer;}
  #wdCont .card .markAllSeen:hover {color:#333;}
  #wdCont .card .markAllSeen i {text-decoration: none;}

  .muteRingAni {
    z-index: 5;
    border: 4px solid #04f; border-radius: 70px; height: 100px; width: 100px;
    position: absolute; left:90px; top:0px;
    animation: pulsate 1s ease-out; opacity: 0.0
  }
  @keyframes pulsate {
    0% {transform: scale(0.1, 0.1); opacity: 0.0;}
    50% {opacity: 1.0;}
    100% {transform: scale(1.2, 1.2); opacity: 0.0;}
  }
  .shadow-top {
    z-index: 2;
    box-shadow: 0px 10px 10px -10px #555 inset;
    margin-top: 5px;
    margin-bottom: -18px;
  }
  .shadow-bottom {
    box-shadow: 0px -10px 10px -10px #555 inset;
    margin-top: -13px;
    margin-right: 9px;
  }
  .shadow-top, .shadow-bottom {
    visibility: hidden;
    opacity: 0;
    position: relative;
    height: 13px;
    transition:opacity .3s, visibility .3s;
  }
  .shadow-top.active, .shadow-bottom.active {
    visibility: visible;
    opacity: 1;
  }
  .greyed-out-card {
    background-color: rgba(200, 200, 200, 0.5); /* Stronger grey */
    pointer-events: none; /* Disable all interactions inside */
    filter: grayscale(80%);
    position: relative;
  }
  .suppressed-tooltip {
    position: fixed;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    padding: 8px 16px;
    border-radius: 6px;
    color: #b26a00;
    font-weight: 500;
    box-shadow: 0 2px 8px #00000022;
    font-size: 13px;
    z-index: 9999;
    pointer-events: none;
    white-space: nowrap;
  }
  </style>




// WEBPACK FOOTER //
// Watchdog.vue?b996b314